import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from '../../containers/Header';
import Popups from '../../containers/Popups';
import Footer from '../../components/Footer';

function App(props) {
  const { children, location } = props;
  const mode = location.hash.replace('#', '');

  return (
    <div>
      <Header location={location} />
      <div className="content-wrap">
        {children}
      </div>
      <Footer />
      <Popups mode={mode} />
    </div>
  );
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect()(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js